import { useTranslation } from "react-i18next";

import { flow, get, keyBy, set, values } from "lodash/fp";
import Schemas from "schemas";

import PopUpWrapper from "./modal-wrapper";

import { Control } from "components/ui-kit/control";
import { Button, Form, Row } from "components/ui-kit/styled-templates";

import useFormControl from "hooks/useFormControl";
import useModal from "hooks/useModal";

import { EForms, EModals, ESteps } from "types/enums";
import { CURRENCIES } from "../../constants/config";

const EditServiceModal = () => {
    const { t } = useTranslation();

    const { data, setValue: setDormitoryInfoValue } = useFormControl({ name: EForms.dormitoryInfo });
    const { onSubmit, clearForm, setValues } = useFormControl({
        name: EForms.editService,
        schema: Schemas[EForms.editService],
    });
    const { close } = useModal(EModals.EditService, { onOpen: setValues, onClose: clearForm });

    const handlers = {
        submit: async (newItem: any) => {
            setDormitoryInfoValue(`${ESteps.Services}`, flow(get(ESteps.Services), keyBy(`id`), set(newItem.id, newItem), values)(data));
            close();
        },
    };
    return (
        <PopUpWrapper name={EModals.EditService}>
            <Form name={EForms.editService} onSubmit={onSubmit(handlers.submit)} extra={`h3 { margin-top: 0; };`}>
                <h3>{t("2iqv968j9it")}</h3>
                <Control.Input name="name" placeholder={t("82qq30gjjxw")} label={t("0iqragf7n1aj")} isRequired />
                <Control.Textarea name="description" placeholder={t("96kcajjlg5s")} label={t("his4a21cgor")} isRequired />
                <Control.Row>
                    {/* <Control.Input name="duration" placeholder="Свободный текст" label="Длительность" isRequired /> */}
                    <Control.Input extra={`flex: 3;`} name="price" placeholder="0" label={t("kubi3gigy6p")} regex="[^0-9]" isRequired />
                    <Control.Select name="currency" extra={`flex: 3;`}  label={'Валюта'} options={CURRENCIES.map((i) => ({ value: i, label: i }))} isRequired />

                    <Control.Switch  name="isFree" label={t("pa571zki648")} extra="justify-content: flex-start; flex: 2;" />
                </Control.Row>
                <Row extra={`width: inherit; justify-content: flex-end; gap: 10px;`}>
                    <Button variant="outlined" background="gray" onClick={close}>
                        {t("x0ng1n512hh")}
                    </Button>
                    <Button type="submit">{t("tb4e0boz5e")}</Button>
                </Row>
            </Form>
        </PopUpWrapper>
    );
};

export default EditServiceModal;
